<template>
  <div v-if="env.key">
      <div class="col-3">
        <label>{{env.label || env.key | nameFormatter}}</label>
      </div>

      <div class="col-9" v-if="env.inputType === 'select'">
        <el-select v-model="env.value" filterable :placeholder="env.placeholder" v-on:change="($event) => envChange(env.key, env.value)">
          <el-option
            v-for="(option, optionsIndex) in env.options"
            :key="optionsIndex"
            :value="option.value"
            :label="option.inputName">
          </el-option>
        </el-select>
      </div>
      <div class="col-9" v-else>
          <IccUpload
              style="float: left; margin: 0.2rem 0 0.2rem 0"
              :key="env.label || env.key"
              :label="env.key"
              :value.sync="env.value"
              v-if="isICC"
          />
          <input
          class="form-control form-control-sm"
          :placeholder="env.key | nameFormatter"
          :type="env.inputType"
          v-model="env.value"
          v-on:change="($event) => envChange(env.key, env.value)" />
      </div>
  </div>
</template>
<script>
import IccUpload from "@/components/Panel/Registration/Shops/SubForms/Envs/IccUpload";
export default {
  name: "Input",
    components: {IccUpload},
    props: {
    env: {
      type: Object,
      default: {}
    }
  },
  filters: {
    nameFormatter: function(stringValue) {
      let firstToUpperCase =
        stringValue.charAt(0).toUpperCase() +
        stringValue.slice(1).toLowerCase();
      let removeUnderscore = firstToUpperCase.replace(
        new RegExp("_", "g"),
        " "
      );
      return removeUnderscore;
    }
  },
  data: () => ({

  }),
  computed: {
      isICC(){
          return ['icc_profile_rs1','icc_profile_ds820'].includes(this.env.label || this.env.key);
      }
  },
  methods: {
    envChange(key, value){
      this.$emit("envChange", key, value);
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
